import SignalRHubs from 'stores/business/hubs/SignalRHubs';
import {fastInvokeAPIPromise} from 'lib/fastSignalRHelper';
import {SignalREventInstrumentManagement, SignalRHub} from '../constants/dataEnum';

const getHub = () => SignalRHubs.getHub(SignalRHub.INSTRUMENT_MANAGEMENT);

export const updateInstrumentRunningProcess = async (username, processName) => {
  let response;
  const Hub = getHub();

  try {
    response = await fastInvokeAPIPromise(Hub, SignalREventInstrumentManagement.UPDATE_STATUS, username, processName);
  } catch (error) {
    console.error('error in updateInstrumentRunningProcess', error);
  }
  return response;
};

export const resetInstrumentRunningProcess = async () => {
  let response;
  const Hub = getHub();

  try {
    response = await fastInvokeAPIPromise(Hub, SignalREventInstrumentManagement.REMOVE_STATUS);
  } catch (error) {
    console.error('error in resetInstrumentRunningProcess', error);
  }
  return response;
};

export const getInstrumentProcessStatus = async () => {
  let response;
  const Hub = getHub();

  try {
    response = await fastInvokeAPIPromise(Hub, SignalREventInstrumentManagement.GET_STATUS);
  } catch (error) {
    console.error('error in getInstrumentProcess', error);
  }
  return response;
};
